<template lang="pug">
v-container(
  fluid
  id="website-theme-preview"
  fill-height
  class=" tw-p-0 tw-m-0  tw-items-start tw-content-start tw-overflow-x-hidden"
)
  kubiqa-website-themes-theme-a-components-shared-top-navigation
  div(class="d-flex flex-row tw-relative flex-grow-1 tw-w-full tw-h-full tw-z-0")
    div(class="d-flex tw-w-full tw-p-0 tw-m-0 tw-z-0 tw-absolute tw-bg-teal-darken-4  tw-h-full ")
      template(v-if="!page.background_image")
        v-img(:src="sampleWebsiteImage('beachHouse', 1080, 1080)" class="tw-opacity-75")
      template(v-else)
        v-img(:src="path(page.background_image)" class="tw-opacity-75")
    div(class="d-flex tw-w-full tw-items-center tw-relative tw-z-10 ")
      v-container(fluid pa-0 ma-0)
        v-row(no-gutters align="center" justify="center" class="  ")
          v-col(cols="12" class="tw-text-center")
            div(class="tw-grid")
              div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1")
                kubiqa-website-shared-widget-editor(
                  page="home"
                  placement="call_out"
                  @content="(content) => (content != null ? ((defaultCallout = false), key++) : ((defaultCallout = true), key++))"
                )
              div(v-if="defaultCallout" :key="key" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle")
                div(class="tw-h-full  tw-items-center tw-flex")
                  v-row(no-gutters justify="center")
                    v-col(cols="9")
                      span(class="tw-font-bold tw-text-white tw-text-2xl") Find your next home
        v-row(dense align="center" justify="center" class="tw-mx-auto tw-mt-6 ")
          v-col(cols="auto")
            v-combobox(solo :items="['Rent', 'Buy']" flat hide-details)
          v-col(cols="4")
            v-text-field(solo flat hide-details label="Address")
          v-col(cols="auto")
            v-btn(
              @click=""
              color="black"
              width="48"
              height="48"
              elevation="0"
            )
              v-icon(large) mdi-magnify
  div(class="d-flex flex-row tw-w-full")
    v-row(no-gutters align="center" justify="space-around")
      v-col(cols="12")
        div(class="tw-grid")
          div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1")
            kubiqa-website-shared-widget-editor(
              page="home"
              placement="description"
              @content="(content) => (content != null ? ((defaultDescription = false), key++) : ((defaultDescription = true), key++))"
            )
          div(v-if="defaultDescription" :key="key" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle")
            div(class="tw-h-full  tw-items-center tw-flex")
              v-row(no-gutters justify="center")
                v-col(cols="9")
                  span(class="tw-font-bold tw-text-white tw-text-2xl") Description

  kubiqa-website-themes-theme-a-components-home-listings
  kubiqa-website-themes-theme-a-components-shared-footer
</template>
<script>
export default {
  data() {
    return {
      key: 0,
      defaultCallout: null,
      defaultDescription: null,
    };
  },
  computed: {
    page() {
      return this.$store.state.website.website.pages.home;
    },
  },
};
</script>
